import axios from 'axios';

const API_URL = 'https://taskflow.zikprint.com';

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true, // חשוב! לשליחת cookies עם Google OAuth
  headers: {
    'Content-Type': 'application/json'
  }
});

// Auth
export const loginWithGoogle = () => {
  window.location.href = `${API_URL}/auth/google`;
};

export const logout = async () => {
  return await api.get('/auth/logout');
};

export const checkAuthStatus = async () => {
  return await api.get('/auth/status');
};
export const getCurrentUser = async () => {
  return await api.get('/auth/status');
};
// Groups
export const getGroups = async () => {
  return await api.get('/api/groups');
};

export const createGroup = async (groupData) => {
  return await api.post('/api/groups', groupData);
};

export const getGroup = async (groupId) => {
  return await api.get(`/api/groups/${groupId}`);
};
export const updateGroup = async (groupId, groupData) => {
  return await api.patch(`/api/groups/${groupId}`, groupData);
};
export const addMemberToGroup = async (groupId, email) => {
  return await api.post(`/api/groups/${groupId}/members`, { email });
};

export const removeMemberFromGroup = async (groupId, userId) => {
  return await api.delete(`/api/groups/${groupId}/members/${userId}`);
};

export const deleteGroup = async (groupId) => {
  return await api.delete(`/api/groups/${groupId}`);
};

export const promoteToAdmin = async (groupId, userId) => {
  return await api.post(`/api/groups/${groupId}/promote/${userId}`);
};

export const demoteFromAdmin = async (groupId, userId) => {
  return await api.post(`/api/groups/${groupId}/demote/${userId}`);
};

export const leaveGroup = async (groupId) => {
  return await api.post(`/api/groups/${groupId}/leave`);
};

// Tasks
export const getGroupTasks = async (groupId) => {
  return await api.get(`/api/tasks/group/${groupId}`);
};



export const getMyTasks = async () => {
  return await api.get('/api/tasks/my-tasks');
};

export const getMyTasksOrdered = async () => {
  return await api.get('/api/tasks/my-tasks-ordered');
};

export const getAllMyGroupsTasks = async () => {
  return await api.get('/api/tasks/all-my-groups');
};

export const createTask = async (taskData) => {
  return await api.post('/api/tasks', taskData);
};

export const getTask = async (taskId) => {
  return await api.get(`/api/tasks/${taskId}`);
};

export const closeTask = async (taskId) => {
  return await api.patch(`/api/tasks/${taskId}/close`);
};
export const updateTaskStatus = async (taskId, status) => {
  return await api.patch(`/api/tasks/${taskId}/status`, { status });
};

export const updateTask = async (taskId, taskData) => {
  return await api.patch(`/api/tasks/${taskId}`, taskData);
};
export const deleteTask = async (taskId) => {
  return await api.delete(`/api/tasks/${taskId}`);
};

export const reorderTasks = async (tasks) => {
  return await api.patch('/api/tasks/reorder', { tasks });
};

export const getTasksByUser = async (groupId, userId) => {
  return await api.get(`/api/tasks/by-user/${groupId}/${userId}`);
};

export const reorderUserTasks = async (groupId, userId, tasks) => {
  return await api.patch('/api/tasks/reorder-user', { groupId, userId, tasks });
};

export const addTaskComment = async (taskId, text) => {
  return await api.post(`/api/tasks/${taskId}/comments`, { text });
};
// Invitations
export const getInvitation = async (token) => {
  return await api.get(`/api/invitations/${token}`);
};

export const acceptInvitation = async (token) => {
  return await api.post(`/api/invitations/${token}/accept`);
};


// Notifications
export const getUnshownNotifications = async () => {
  return await api.get('/api/notifications/unshown');
};

export const markNotificationsShown = async (notificationIds) => {
  return await api.patch('/api/notifications/mark-shown', { notificationIds });
};

export const getAllNotifications = async () => {
  return await api.get('/api/notifications');
};

export const updateDisplayName = async (displayName) => {
  return await api.patch('/auth/update-display-name', { displayName });
};

// Web Push Notifications
export const getVapidPublicKey = async () => {
  return await api.get('/api/users/vapid-public-key');
};

export const saveWebPushSubscription = async (subscription) => {
  return await api.post('/api/users/web-push-subscription', { subscription });
};

// המרת VAPID key לפורמט הנכון
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

// הרשמה להתראות Web Push
export const subscribeToWebPush = async () => {
  try {
    // בדיקה שהדפדפן תומך
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
      console.log('Web Push not supported');
      return { success: false, reason: 'not_supported' };
    }

    // בדיקת הרשאה
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.log('Notification permission denied');
      return { success: false, reason: 'permission_denied' };
    }

    // קבלת ה-VAPID key מהשרת
    const vapidResponse = await getVapidPublicKey();
    const vapidPublicKey = vapidResponse.data.publicKey;

    // קבלת Service Worker registration
    const registration = await navigator.serviceWorker.ready;

    // יצירת subscription
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapidPublicKey)
    });

    // שליחת ה-subscription לשרת
    await saveWebPushSubscription(subscription.toJSON());

    console.log('Web Push subscription successful');
    return { success: true };
  } catch (error) {
    console.error('Error subscribing to Web Push:', error);
    return { success: false, reason: 'error', error };
  }
};

// Manuals & Chat
export const uploadManual = async (formData) => {
  return await api.post('/api/manuals/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const getManuals = async () => {
  return await api.get('/api/manuals');
};

export const deleteManual = async (id) => {
  return await api.delete(`/api/manuals/${id}`);
};

export const getPrinterModels = async () => {
  return await api.get('/api/manuals/printer-models');
};

export const askQuestion = async (question, printerModel) => {
  return await api.post('/api/manuals/chat', { question, printerModel });
};

export default api;